import { render, staticRenderFns } from "./FillLegalProjectInformationStep.vue?vue&type=template&id=25afca91&"
import script from "./FillLegalProjectInformationStep.vue?vue&type=script&lang=js&"
export * from "./FillLegalProjectInformationStep.vue?vue&type=script&lang=js&"
import style0 from "./FillLegalProjectInformationStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports